import React from 'react'

export default function Success({message}) {  
    return <div style={{ color: 'green' }}>{ message? message : 'Success!' }</div>  
}
